import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ad } from './types';
import { RootState } from '@/store';
import { CreateAd } from '@/models/ad/types';

type AdState = {
  userAds: Ad[];
  createAd: CreateAd;
  promoCode: string;
  price: string;
};

export const initialState: AdState = {
  userAds: [],
  createAd: {
    title: '',
    zones: [],
    url: '',
    type: '',
    format: '',
    displays: 0,
    views: 0,
    price: 0,
    qrUrl: '',
    qrText: '',
  },
  promoCode: '',
  price: '',
};

export const adSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    resetZones: (state) => {
      state.createAd.zones = [];
    },
    setPromoCode: (state, action: PayloadAction<{ code: string }>) => {
      state.promoCode = action.payload.code.toUpperCase();
    },
    resetPromoCode: (state) => {
      state.promoCode = '';
    },
  },
});

export const { resetZones, setPromoCode, resetPromoCode } = adSlice.actions;

export const adReducer = adSlice.reducer;
export const selectAdPrice = (state: RootState) => state.adReducer.price;
